<template>
  <div class="block">
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group flex-grow-1 mr-5">
        <div class="prepend-icon" style="top: 45%;">
          <v-icon>search</v-icon>
        </div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋:Name or Company"
          v-model="filter.keyword"
        />
      </div>
      <SimpleSelectWithSearchInput
        class="mr-5"
        buttonPlaceholder="篩選TYPE"
        modalWidth="200px"
        :isOnlyShowButtonPlaceholder="true"
        :options="typeOptions"
        :selectedValue.sync="filter.type"
      >
      </SimpleSelectWithSearchInput>
      <SegmentalControls
        class="mr-5"
        v-model="filter.isSubscribe"
      ></SegmentalControls>
      <button class="btn btn-primary w-88px" @click="getShareholderEmails">搜尋</button>
    </div>

    <!-- table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <div v-if="lengthOfisCheckedList > 0"
             class="form-item d-flex align-center px-5 h-60px batch">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button class="btn btn-danger mr-10px" @click="multiDelete">
              <v-icon color="white" class="mr-2">delete</v-icon>
              <span>刪除</span>
            </button>
          </div>
          <div>
            <button class="btn mr-10px" @click="multiToggleSubscribe(true)">訂閱</button>
          </div>
          <div>
            <button class="btn" @click="multiToggleSubscribe(false)">未訂閱</button>
          </div>
        </div>
        <tr>
          <th>
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </th>
          <th class="text-left">Name</th>
          <th class="text-left">Company</th>
          <th class="text-left">Email</th>
          <th class="text-left">Type</th>
          <th class="text-left">Unsubscribe</th>
          <th class="text-left">編輯</th>
          <th class="text-left">刪除</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in shareholderEmails"
          :key="item.id"
        >
          <td>
            <v-checkbox v-model="item.isChecked"></v-checkbox>
          </td>
          <td class="w-140px">{{ item.name }}</td>
          <td>{{ item.company }}</td>
          <td>{{ item.email }}</td>
          <td>{{ getType(item.type) }}</td>
          <td>
            <div class="h5 col-subscribe ml-auto">
              <button
                v-if="item.is_subscribe == 1"
                class="btn btn-outlined"
                :style="{
                width: '101px',
              }"
                @click="toggleSubscribe(item.id)"
              >
                Subscribe
              </button>
              <button
                v-else
                class="btn btn-outlined danger-500--text"
                :style="{
                  border: '1px solid #f60000',
                  width: '101px',
                }"
                @click="toggleSubscribe(item.id)"
              >
                Unsubscribe
              </button>
            </div>
          </td>
          <td>
            <button class="btn square" @click="editItem(item.id)">
              <v-icon>edit</v-icon>
            </button>
          </td>
          <td>
            <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- table footer -->
    <Pagination @handleNextPreEvent="getShareholderEmails" model="shareholderEmail"></Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SegmentalControls from '@/components/SegmentalControls.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import Pagination from '@/components/Pagination.vue';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    SegmentalControls,
    deleteDialog,
    Pagination,
  },
  data: () => ({
    // filter
    checkAllStatus: false, // left top checkbox status
    // selectedItems
    selectedItems: [],
  }),
  computed: {
    ...mapState('shareholderEmail', ['shareholderEmails', 'filter', 'typeOptions']),
    lengthOfisCheckedList() {
      return this.shareholderEmails.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      const isCheckedList = this.shareholderEmails.filter(
        (item) => item.isChecked,
      );
      if (
        isCheckedList.length === 0 ||
        isCheckedList.length === this.shareholderEmails.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.shareholderEmails.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.shareholderEmails.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.shareholderEmails.length) {
        this.checkAllStatus = true;
      }
    },
  },
  methods: {
    ...mapActions('shareholderEmail', {
      getShareholderEmails: 'find',
      destroyShareholderEmail: 'destroy',
      toggleEmailSubscribe: 'toggleSubscribe',
      clear: 'clear',
    }),
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.shareholderEmails.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.shareholderEmails.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    editItem(id) {
      this.$router.push({
        name: 'EmailAlertsInfoEdit',
        params: { id },
      });
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyShareholderEmail(id).then(() => {
        this.getShareholderEmails();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroyShareholderEmail(id).then(() => {});
      });
      this.getShareholderEmails();
    },
    toggleSubscribe(id) {
      this.toggleEmailSubscribe(id).then(() => this.getShareholderEmails());
    },
    async multiToggleSubscribe() {
      await this.isCheckedListIds.forEach((id) => {
        this.toggleEmailSubscribe(id).then(() => {});
      });
      this.getShareholderEmails();
    },
    stampToDate(stamp) {
      const dateObj = new Date(stamp);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const date = String(dateObj.getDate()).padStart(2, '0');

      return `${year}/${month}/${date}`;
    },
    getType(t) {
      const type = this.typeOptions.find((o) => o.value === t);
      return type.text;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-name {
    width: 170px;
    margin-right: 10px;
  }
  .col-company {
    width: 200px;
    margin-right: 10px;
  }
  .col-email {
    width: 230px;
    margin-right: 10px;
  }
  .col-type {
    width: 50px;
  }
  .col-subscribe {
    width: 101px;
    margin-right: 10px;
    text-align: center;
  }
}
</style>
